import { graphql } from 'react-apollo';

import ActionItemForm from '-/components/profiles/forms/ActionItem';
import { UPDATE_COMPANY_ACTION_ITEM } from '-/gql/company';

export default graphql(UPDATE_COMPANY_ACTION_ITEM, {
    name: 'updateActionItem'
})(ActionItemForm);
